import { resourceReducer, getResources } from 'redux-resource';
import { reset, httpStatusCodes } from 'redux-resource-plugins';
import metaReducer from './metaReducer';

const subs = resourceReducer('subs', {
  plugins: [reset, metaReducer, httpStatusCodes],
});

export default subs;

export const getAllSubs = (state, page = 1) =>
  getResources(state, `page${page}`);
export const getAllUserSubs = (state, userId) =>
  getResources(state, `userSubs${userId}`);
export const getSearchSubs = (state, page = 1) =>
  getResources(state, `searchPage${page}`);
export const getUserSubs = (state) => getResources(state, 'userSubs');
export const getAllSubsCount = (state, page) =>
  state.requests[`fetchByUser${page}`] &&
  state.requests[`fetchByUser${page}`].count;
export const getSub = (state, id) => state.resources[id];
export const getSubNotFound = (state, id) =>
  state.meta[id] && state.meta[id].readStatusCode === 404;
export const getSubNotFoundFromFind = (state) =>
  Boolean(
    state.requests &&
      state.requests.find &&
      state.requests.find.statusCode === 404,
  );
export const getSetCsaStatus = (state) =>
  state.requests.setCsa && state.requests.setCsa.status;
export const getUpdateDeviceStatus = (state) =>
  state.requests.updateDevice && state.requests.updateDevice.status;
export const getDeviceDetails = (state) =>
  state.requests.updateDevice && state.requests.updateDevice.details;
export const getUpdatePlanStatus = (state) =>
  state.requests.updatePlan && state.requests.updatePlan.status;
export const getPortResponse = (state, subId) =>
  state.requests[`updatePort${subId}`];
export const getUpdateStatusResponse = (state, subId) =>
  state.meta[subId] && state.meta[subId].updateStatus;
export const getPortModifyResponse = (state, subId) =>
  state.requests[`portModify${subId}`];
export const getActivationResponse = (state, subId) =>
  state.meta[subId] && state.meta[subId].activation;
export const getPortInfo = (state, subId) =>
  state.meta[subId] && state.meta[subId].portInfo;
export const getAllPortInfo = (state, subId) =>
  state.meta[subId] && state.meta[subId].allPortInfo;
export const getSubDataUsage = (state, subId) =>
  state.meta[subId] && state.meta[subId].dataUsage;
export const getSubVoiceUsage = (state, subId) =>
  state.meta[subId] && state.meta[subId].voiceUsage;
export const getSubRoamingUsage = (state, subId) =>
  state.meta[subId] && state.meta[subId].roamingUsage;
export const getSubDailyUsage = (state, subId) =>
  state.meta[subId] && state.meta[subId].dailyUsage;
export const getSubUpcomingPlan = (state, subId) =>
  state.meta[subId] && state.meta[subId].upcomingPlan;
export const getPortMessage = (state, subId) =>
  state.meta[subId] && state.meta[subId].wholesalePortMessageTypeInfo;
export const getPortMessageArray = (state, subId) =>
  state.meta[subId] && state.meta[subId].isArray;
export const getFilteredSubs = (state, requestKey, page) =>
  getResources(state, requestKey);
export const getFilteredSubsCount = (state, requestKey) =>
  state.requests[requestKey] && state.requests[requestKey].count;
export const getAllInitialsSubs = (state) =>
  getResources(state, `allInitialsSubs`);
export const getAllInitialsSubsStatus = (state) =>
  state.requests.fetchAllInitialsSubs &&
  state.requests.fetchAllInitialsSubs.status;
export const getSubServiceCodesError = (state, subId) =>
  state.meta[subId] && state.meta[subId].serviceCodesError;
export const getFilteredSprintSubs = (state, filter, page) =>
  getResources(state, `${filter}Subs${page}`);
